import React from 'react';

export const RevoLogo = ({ className = "", size = "md" }) => {
  const sizeClasses = {
    sm: "h-8",
    md: "h-10",
    lg: "h-12",
    xl: "h-16",
    xxl: "h-24"
  };
  
  return (
    <img 
      src="/revo-app-logo.png" 
      alt="Revo APP" 
      className={`${sizeClasses[size]} ${className}`}
    />
  );
};